import signedFetch from '../util/signedFetch.js';

export default (userId, os, arch) =>
  signedFetch('orbGetAppDownloadUrl', `${__API_BASE__}/orb/app-download-url?userId=${userId}&os=${os}&arch=${arch}`);
